import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import BorobudurAtSunrise from "../assets/img/Blogs/Indonesia/BorobudurAtSunrise.jpg";
import GiliIslands from "../assets/img/Blogs/Indonesia/GiliIslands.jpg";
import JakartaSkyline from "../assets/img/Blogs/Indonesia/JakartaSkyline.jpg";
import PinkBeach from "../assets/img/Blogs/Indonesia/PinkBeach.jpg";
import UbudsRiceTerraces from "../assets/img/Blogs/Indonesia/UbudsRiceTerraces.jpg";
import BaliBeaches from "../assets/img/Blogs/Indonesia/BaliBeaches.jpg";

const Indonesia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap indonesiaBlogBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>Indonesia’s Top 5 Must-Visit Places</h2>
                  <p>
                    Indonesia, an archipelago of over 17,000 islands, is a land
                    of diverse cultures, breathtaking landscapes, and unique
                    wildlife. Whether you seek stunning beaches, ancient
                    temples, or vibrant cities, Indonesia offers an
                    unforgettable adventure. Here are the top five must-visit
                    places:
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={UbudsRiceTerraces} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2>Bali – The Island of Gods</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A tropical paradise with temples, beaches, and vibrant
                      culture.
                    </p>
                  </div>
                  <p>
                    Bali is Indonesia’s most famous island, known for its
                    stunning beaches, lush rice terraces, and spiritual
                    atmosphere. Uluwatu Temple, perched on a cliff, offers
                    breathtaking sunset views. Ubud is the cultural heart, home
                    to art markets and monkey forests. Don’t miss the
                    Tegallalang Rice Terraces, a perfect spot for photography
                    and relaxation.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Uluwatu Temple</p>
                    </li>
                    <li>
                      <p>Ubud</p>
                    </li>
                    <li>
                      <p>Tegallalang Rice Terraces</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={JakartaSkyline} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Jakarta – The Capital City</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A vibrant city blending modern skyscrapers with colonial
                      heritage.
                    </p>
                  </div>
                  <p>
                    Jakarta, the bustling capital of Indonesia, is a melting pot
                    of cultures and modern development. Visit the National
                    Monument (Monas) for panoramic city views. Explore Kota Tua,
                    the old town with Dutch colonial architecture and charming
                    cafés. For family-friendly fun, Ancol Dreamland offers
                    beaches, amusement parks, and an aquarium.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>National Monument</p>
                    </li>
                    <li>
                      <p>Kota Tua</p>
                    </li>
                    <li>
                      <p>Ancol Dreamland</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={BorobudurAtSunrise} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Yogyakarta – The Cultural Heart of Indonesia</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>Home to ancient temples and rich Javanese heritage.</p>
                  </div>
                  <p>
                    Yogyakarta is a must-visit for history and culture lovers.
                    The awe-inspiring Borobudur Temple, a UNESCO World Heritage
                    Site, is the world’s largest Buddhist temple. Nearby,
                    Prambanan Temple, a majestic Hindu complex, showcases
                    intricate carvings and centuries-old history. The city
                    itself is a hub for traditional arts, crafts, and delicious
                    Javanese cuisine.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Borobudur Temple</p>
                    </li>
                    <li>
                      <p>Prambanan Temple</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={PinkBeach} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2> Komodo Island – The Land of Dragons</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>A one-of-a-kind wildlife and marine adventure.</p>
                  </div>
                  <p>
                    Komodo Island is the only place in the world where you can
                    see the legendary Komodo dragons in their natural habitat.
                    After an exciting trek to see these creatures, relax at the
                    unique Pink Beach, famous for its rosy-colored sand. The
                    surrounding waters offer world-class diving and snorkeling
                    with vibrant coral reefs and marine life.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Komodo Dragons</p>
                    </li>
                    <li>
                      <p>Pink Beach</p>
                    </li>
                    <li>
                      <p>Diving Spots</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={GiliIslands} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2> Lombok – An Untouched Tropical Paradise</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A hidden gem with adventure, waterfalls, and pristine
                      beaches.
                    </p>
                  </div>
                  <p>
                    Lombok is Bali’s quieter neighbor, offering equally stunning
                    landscapes with fewer crowds. Adventurers can hike Mount
                    Rinjani, Indonesia’s second-highest volcano, for
                    breathtaking crater views. The Gili Islands, just offshore,
                    are known for crystal-clear waters, sea turtles, and relaxed
                    island vibes. Senggigi Beach is perfect for watching
                    spectacular sunsets.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Mount Rinjani</p>
                    </li>
                    <li>
                      <p> Gili Islands</p>
                    </li>
                    <li>
                      <p>Senggigi Beach</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="finalThouthWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Final Thoughts</h2>
                <p>
                  Indonesia is a country of wonders, offering everything from
                  cultural heritage to stunning natural beauty. Whether you
                  explore Bali’s lush landscapes, discover Jakarta’s city life,
                  or encounter the legendary Komodo dragons, Indonesia promises
                  an unforgettable experience.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={BaliBeaches} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2>Start planning your Indonesian adventure today!</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Indonesia;
